import React from 'react';
import { ManualAlert } from '@conviva/portal-graphql-schema';
import Stat from '@components/common/Stat';
import { Row } from './styled';

interface IProps {
  alerts: ManualAlert[];
  status: string;
  setStatus: (status: string) => void;
}

const Toggles = ({ alerts, setStatus, status }: IProps) => {
  const items = [
    {
      key: 'all',
      title: 'Total Alerts',
      value: `${alerts.length}`,
    },
    {
      key: 'enabled',
      title: 'Enabled Alerts',
      value: `${alerts.filter((a) => a.state).length}`,
    },
    {
      key: 'disabled',
      title: 'Disabled Alerts',
      value: `${alerts.filter((a) => !a.state).length}`,
    },
  ];

  const onClick = (key) => {
    setStatus(key);
  };

  return (
    <Row>
      <Stat items={items} onClick={onClick} selected={status} />
    </Row>
  );
};

export default Toggles;
